import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useDeliveryTypeReducer = () =>
  useSelector((state: ApplicationState) => state.deliveryTypes);
